module.exports = __webpack_public_path__ + "static/img/ikonaGimp-OFF.79df5319.png";